import service from './axios'

// * 获取用户权限
export const getUserPerm = (data) => service({
  url: '/sys/getUserPerm',
  method: 'post',
  data
})

// * 日志
export const addDownLog = (data) => service({
  url: '/doc/log/addDownLog',
  method: 'post',
  data
})

// * 项目文档权限
export const validateFilePermByUserId = (data) => service({
  url: '/doc/paper/validateFilePermByUserId',
  method: 'post',
  data
})

// * 查询项目的创建人信息
export const getProjectById = (data) => service({
  url: '/info/project/getProjectById',
  method: 'post',
  data
})


// WEBPACK FOOTER //
// ./src/api/permission.api.js